module.exports = __webpack_public_path__ + "img/hzjg3.6d0e6c0f.png";